import React, { useEffect } from 'react';
import DesktopPageHeader from './Desktop';
import MobilePageHeader from './Mobile';
import { getAccountFromStorage, useAccountContextProvider } from '../../../context/account';

export interface IPageHeader {
  icon: React.ReactNode;
  title: React.ReactNode;
  actions?: React.ReactNode;
  ignoreAccount?: boolean;
  disableDownloadBtn?: boolean;
}

function PageHeader({ icon, title, actions, ignoreAccount = false, disableDownloadBtn = false }: IPageHeader) {
  let account = getAccountFromStorage();
  const { account: contentAccount } = useAccountContextProvider();

  useEffect(() => {
    account = getAccountFromStorage();
  }, [contentAccount]);

  const accountName = ignoreAccount ? title : account?.name || title || 'Dashboard';

  return (
    <>
      <DesktopPageHeader
        icon={icon}
        title={
          account ? (
            <div className="flex items-center gap-[15px]">
              <div>{accountName}</div>
              <div className="text-[14px] mt-[5px] opacity-70">{ignoreAccount ? '' : account.number}</div>
            </div>
          ) : (
            title
          )
        }
        actions={actions}
        disableDownloadBtn={disableDownloadBtn}
      />
      <MobilePageHeader
        icon={icon}
        title={
          account ? (
            <div className="flex items-center gap-[15px]">
              <div>{accountName}</div>
              <div className="text-[14px] mt-[5px] opacity-70">{account.number}</div>
            </div>
          ) : (
            title
          )
        }
        actions={actions}
      />
    </>
  );
}

PageHeader.defaultProps = {
  actions: undefined,
};

export default PageHeader;
